import { render, staticRenderFns } from "./AppColumn.vue?vue&type=template&id=f16f7878"
import script from "./AppColumn.vue?vue&type=script&lang=js"
export * from "./AppColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports